var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2 0H7.8C8.46274 0 9 0.488417 9 1.09091V1.63636H10.8C11.4627 1.63636 12 2.12478 12 2.72727V3.81818C12 4.42067 11.4627 4.90909 10.8 4.90909H10.752L10.2 10.9091C10.2 11.5116 9.66277 12 9.00003 12H3.00003C2.33729 12 1.80003 11.5116 1.8021 10.9544L1.24795 4.90909H1.2C0.537258 4.90909 0 4.42067 0 3.81818V2.72727C0 2.12478 0.537258 1.63636 1.2 1.63636H3V1.09091C3 0.488417 3.53726 0 4.2 0ZM3.00006 10.9091L2.45195 4.90914H9.54798L9.00213 10.8638L9.00006 10.9091H3.00006ZM1.2 3.81822V2.72731H10.8V3.81822H1.2ZM7.8 1.09091V1.63636H4.2V1.09091H7.8ZM3.77568 6.38574L4.62421 5.61435L5.99995 6.86502L7.37568 5.61435L8.22421 6.38574L6.84848 7.6364L8.22421 8.88707L7.37568 9.65846L5.99995 8.40779L4.62421 9.65846L3.77568 8.88707L5.15142 7.6364L3.77568 6.38574Z",
    fill: "#607783"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.9581be3db805339aa71f4468f3e749e9.svg";
export { ForwardRef as ReactComponent };